// Network regions (per the brief). Each zone is one region of the Grid; names
// cycle once you pass the last one (Endless keeps going).
export const REGION_NAMES = [
  "Server Farm",
  "Satellite Relay",
  "Fiber Backbone",
  "Power Grid",
  "Cloud Cluster",
  "Deep Core",
  "Quantum Network",
];

export function regionName(zone: number): string {
  return REGION_NAMES[(zone - 1) % REGION_NAMES.length];
}
